import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IValidateAvailabilityPayload } from '@app-store/slices/table/validateAvailability'

interface TaskAction extends Action {
    payload: IValidateAvailabilityPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.validateAvailability

function* validateAvailabilityTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/table/validate-table-availability`, { params: payload })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* validateAvailability(): any {
    yield takeLatest<TaskAction>(onRequest, validateAvailabilityTask)
}

export default validateAvailability
